// src/api/orderApi.js
const API = process.env.REACT_APP_API;

export const getAllOrdersAsAdmin = async () => {
  const response = await fetch(`${API}/orders/all`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include', // ensures cookie is sent
  });

  if (!response.ok) {
    throw new Error('Not authorized or failed to fetch orders');
  }

  return await response.json();
};
